<blaze-panel [hideClose]="!showCloseButton">
  <button icon class="icon-back" blazeIconButton (click)="showPrevPage.emit()">
    <mat-icon svgIcon="icon_chevron_left_16" />
  </button>

  <div title>
    {{ dataset?.name }}
  </div>

  <ng-container actions>
    <button [matMenuTriggerFor]="optionsMenu" blazeIconButton aria-label="Options">
      <mat-icon class="icon-export" svgIcon="icon_more_h_24" />
    </button>
  </ng-container>

  <mat-menu #optionsMenu="matMenu" xPosition="before">
    <button mat-menu-item disableRipple (click)="refreshDataset.emit()">
      <mat-icon class="icon-export" svgIcon="icon_download_16" />
      <span>Refresh column list</span>
    </button>
  </mat-menu>

  <div content class="dataset-preview">
    <blaze-scroller class="absolute inset-0 p-24">
      <table [dataSource]="tableData" class="preview-table" mat-table>
        @for (col of tableColumns; track col) {
          <ng-container matColumnDef="{{ col }}">
            <th mat-header-cell *matHeaderCellDef>{{ col }}</th>
            <td mat-cell *matCellDef="let cell">
              <blaze-cell-preview
                [content]="cell | dataRowFieldValuePipe: col | formatValue: 'text'"
              />
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell h-[100px] text-center" colspan="100%">Dataset is empty</td>
        </tr>
      </table>
    </blaze-scroller>
  </div>
</blaze-panel>
